var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7004 2.83337C9.61557 2.83337 3.06152 9.176 3.06152 17C3.06152 24.824 9.61557 31.1667 17.7004 31.1667C25.7852 31.1667 32.3393 24.824 32.3393 17C32.3393 9.176 25.7852 2.83337 17.7004 2.83337Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38574 25.9898C6.38574 25.9898 9.64878 21.9584 17.7001 21.9584C25.7515 21.9584 29.0147 25.9898 29.0147 25.9898",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7003 17C20.1258 17 22.0919 15.0973 22.0919 12.75C22.0919 10.4028 20.1258 8.5 17.7003 8.5C15.2747 8.5 13.3086 10.4028 13.3086 12.75C13.3086 15.0973 15.2747 17 17.7003 17Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.dc87180b09e2c3f7209b33f43b2118cf.svg";
export { ForwardRef as ReactComponent };